import axios from "axios";
import { Dispatch } from "redux";
import baseUrl from "../../ApiConfig";
import { setupInterceptorsTo } from "../Authentication/Interceptors";
import {
  addPatientImportConfigActionTypes,
  ADD_PATIENT_IMPORT_CONFIG_FAIL,
  ADD_PATIENT_IMPORT_CONFIG_LOADING,
  ADD_PATIENT_IMPORT_CONFIG_SUCCESS,
} from "./ActionTypes";
import {
  AddPatientImportConfigDetails,
  AddPatientImportConfigValue,
} from "./Model";

const userToken = localStorage.getItem("access");
const headers = {
  Accept: "application/json",
  "Content-type": "application/json",
  Authorization: `Bearer ${userToken}`,
};

export const addPatientImportConfigApi = (
  body: AddPatientImportConfigDetails
) => {
  return function (dispatch: Dispatch<addPatientImportConfigActionTypes>) {
    dispatch({
      type: ADD_PATIENT_IMPORT_CONFIG_LOADING,
    });

    setupInterceptorsTo(axios)
      .post(
        baseUrl.baseUrl +
          `/patientapp/api/dataimport/add_patient_import_config`,
        body,
        {
          headers,
        }
      )
      .then((res) => {
        dispatch({
          type: ADD_PATIENT_IMPORT_CONFIG_SUCCESS,
          payload: res.data,
          errRes: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: ADD_PATIENT_IMPORT_CONFIG_FAIL,
          payload: {} as AddPatientImportConfigValue,
          errRes: error.response.data.message,
        });
      });
  };
};
